import { FormInstance, Rule, RuleObject } from "antd/lib/form"

import i18n from "Shared/locales/i18n"
import { getFilteredExpenseStatusArrayForExport } from "Shared/utils/expense.utils"

import { checkMaxNumber, checkMinNumber } from "./utils.rules"

export const generateRules = (formInstance: FormInstance): { [key: string]: Array<Rule> } => ({
    required: [{ required: true, message: i18n.t("validation:required") }],
    status: [
        {
            validator: (_rule: RuleObject, value: any) => {
                const exportFormat = formInstance.getFieldValue("format")
                if (value !== "" && !getFilteredExpenseStatusArrayForExport(exportFormat).includes(Number(value))) {
                    return Promise.reject(i18n.t("validation:export_status_not_supported"))
                }

                return Promise.resolve()
            },
        },
    ],
    minAmount: [
        {
            validator: (_rule: any, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
        },
    ],
    maxAmount: [
        {
            validator: (_rule: any, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
        },
    ],
})
